import { Box, Flex, Stat, StatLabel, StatNumber, useColorModeValue } from "@chakra-ui/react";
import { FC, ReactNode } from "react";

interface DashboardMeasurementProps {
    title: string;
    stat: number;
    icon: ReactNode;
}

const DashboardMeasurement: FC<DashboardMeasurementProps> = ({ title, stat, icon }) => {
    return (
        <Stat
            px={{ base: 2, md: 4 }}
            py={'2'}
            shadow={'md'}
            border={'1px solid'}
            borderColor={useColorModeValue('teal.700', 'gray.800')}
            rounded={'lg'}
        >
            <Flex justifyContent={'space-between'}>
                <Box pl={{ base: 2, md: 4 }} color={useColorModeValue('teal.700', 'gray.800')}>
                    <StatLabel fontSize={'xs'} fontWeight={'medium'} isTruncated>
                        {title}
                    </StatLabel>
                    <StatNumber fontSize={'large'} fontWeight={'medium'}>
                        {String.toFormatSeparator(stat, 0, 0)}
                    </StatNumber>
                </Box>
                <Box
                    my={'auto'}
                    color={useColorModeValue('teal.700', 'gray.800')}
                    alignContent={'center'}>
                    {icon}
                </Box>
            </Flex>
        </Stat>
    );
};

export default DashboardMeasurement;